export const settings = {
    apiKey: '6d306d5b-e529-437c-a96b-b803e25a3042\n',
    lang: 'ru_RU',
    coordorder: 'latlong',
    version: '2.1'
}
